import { render, staticRenderFns } from "./OrderCompletionMarkSortingLocationAsComplete.vue?vue&type=template&id=680f4172&scoped=true&"
import script from "./OrderCompletionMarkSortingLocationAsComplete.vue?vue&type=script&lang=js&"
export * from "./OrderCompletionMarkSortingLocationAsComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f4172",
  null
  
)

export default component.exports